import React, { useState } from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import {
  CodeField,
  Cursor,
  isLastFilledCell,
  MaskSymbol,
  useBlurOnFulfill,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";
import { PaymentIcon } from "react-native-payment-icons";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import Button from "../../../components/Button";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function ConfirmCvv({
  modalVisible,
  setModalVisible,
  onPress,
  countCell = 3,
}) {
  const CELL_COUNT = countCell;
  const [cvv, setCvv] = useState("");
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value: cvv,
    setValue: setCvv,
  });

  const ref = useBlurOnFulfill({ cvv, cellCount: CELL_COUNT });

  const renderCell = ({ index, symbol, isFocused }) => {
    let textChild = null;

    if (symbol) {
      textChild = (
        <MaskSymbol
          maskSymbol="*"
          isLastFilledCell={isLastFilledCell({ index, cvv })}
          delay={300}
        >
          {symbol}
        </MaskSymbol>
      );
    } else if (isFocused) {
      textChild = <Cursor />;
    }

    return (
      <Text
        key={index}
        style={[styles.cell, isFocused && styles.focusCell]}
        onLayout={getCellOnLayoutHandler(index)}
      >
        {textChild}
      </Text>
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      style={{ backgroundColor: "#000" }}
      visible={modalVisible}
      onRequestClose={() => setModalVisible(!modalVisible)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Icon
            name="close"
            size={32}
            onPress={() => {
              setCvv("");
              setModalVisible(!modalVisible);
            }}
            style={styles.closeButton}
          />
          <View style={styles.titleView}>
            <PaymentIcon width={64} type="cvv" />
            <Text style={styles.titleText}>{"Código de segurança"}</Text>
            <Text style={styles.titleText}>{"(CVV)"}</Text>
          </View>
          <View style={styles.subTitleView}>
            <Text style={styles.subTitleText}>
              {
                "Para realizar o seu pagamento, digite o código de segurança do seu cartão."
              }
            </Text>
          </View>
          <CodeField
            ref={ref}
            {...props}
            value={cvv}
            onChangeText={setCvv}
            cellCount={CELL_COUNT}
            rootStyle={styles.codeFieldRoot}
            keyboardType="number-pad"
            textContentType="oneTimeCode"
            renderCell={renderCell}
          />
          <View style={styles.viewButton}>
            <Button
              textoBotao={"Confirmar"}
              estilo={{ backgroundColor: Colors.SUCCESS }}
              onPress={() => {
                setModalVisible(!modalVisible);
                onPress(cvv);
                setCvv("");
              }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
  },
  subTitleView: {
    alignItems: "center",
    width: "90%",
  },
  subTitleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK,
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  closeButton: {
    marginLeft: "auto",
    color: Colors.GRAY_DARK,
  },
  viewButton: {
    marginTop: 16,
  },
  codeFieldRoot: { marginTop: 20 },
  cell: {
    width: 48,
    height: 48,
    lineHeight: 38,
    fontSize: 24,
    borderWidth: 1,
    borderColor: Colors.GRAY_DARK,
    textAlign: "center",
    margin: 4,
    borderRadius: 8,
  },
});
